import getTextCell from './templates/getTextCell';
import { getIndentTree } from './helpers';
import BaselineGrid from '../../baselines/grid';
import getDefaultCell from './templates/getDefaultCell';
import getOverloadCell from './templates/getOverloadCell';
import getStartDateCell from './templates/getStartDateCell';
import getEndDateCell from './templates/getEndDateCell';
import getOverdueCell from './templates/getOverdueCell';

const CELL_TEMPLATE_DATA_BUILDERS = {
  text: prepareDataForTextCell,
};

function prepareDataForTextCell(commonData) {
  const {
    instance, task,
  } = commonData;
  const isJiraRootProject = instance.config.isJira
    && (instance.config.gantt_id <= GT.lastProjectIdBeforeRootTask)
    && (instance.config.multiview ? task.$level === 2 : task.$level === 1);

  return {
    ...commonData,
    isJiraRootProject,
  };
}

function prepareDataForCellTemplate(commonData) {
  const { column: { name: columName } } = commonData;

  if (CELL_TEMPLATE_DATA_BUILDERS[columName]) {
    return CELL_TEMPLATE_DATA_BUILDERS[columName](commonData);
  }

  return commonData;
}

function prepareCommonCellData(instance, task, column) {
  const cellValue = column.template ? column.template(task) : task[column.name];
  const isTotalEstimateTask = instance.config.multiview ? task.$level === 1 : task.$level === 0;
  const baselineValue = instance.config.baseline ? BaselineGrid.getBaselineValue(task, column, cellValue) : null;
  const isBaseline = (instance.config.baseline && baselineValue);
  const isButton = task.type === instance.config.types.button;

  return {
    baselineValue,
    column,
    cellValue,
    instance,
    isTotalEstimateTask,
    isBaseline,
    isButton,
    task,
  };
}

/**
 * @param {Object} instance
 * @param {Object} task
 * @param {Object} column
 * @returns string
 */
export default function getCellHTML(instance, task, column) {
  const commonCellData = prepareCommonCellData(instance, task, column);
  const dataForTemplateBuild = prepareDataForCellTemplate(commonCellData);

  if (column.name === 'text') {
    const indentTree = getIndentTree(instance, task, column, commonCellData.isButton);

    return `${indentTree} ${getTextCell(dataForTemplateBuild)}`;
  }

  if (column.name === 'overdue') {
    return getOverdueCell(dataForTemplateBuild);
  }

  if (column.name === 'overload') {
    return getOverloadCell(dataForTemplateBuild);
  }

  if (column.name === 'start_date') {
    return getStartDateCell(dataForTemplateBuild);
  }

  if (column.name === 'end_date') {
    return getEndDateCell(dataForTemplateBuild);
  }

  // if (column.name === 'attachments') {
  //   return getAttachmentsCell(dataForTemplateBuild);
  // }

  return getDefaultCell(dataForTemplateBuild);
}
